module.exports = __webpack_public_path__ + "static/media/776549b3-1d37-47ae-90fc-e88f7e05a299.bc850e85.jpeg";